module.exports = __webpack_public_path__ + "img/Upgrading.ec5c4d1f.png";